module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/library/modules/_redefine.js
// module id = ../../../node_modules/core-js/library/modules/_redefine.js
// module chunks = 0